export const apiKey = 'f3e18f5e1a085f2714ead6411e777925'
export const endPoint = 'https://api.themoviedb.org/3/'
export const posterEndPoint = 'https://image.tmdb.org/t/p/w500'
export const youtubeEndPoint = 'https://www.youtube.com/watch?v='